<template>
  <div>
    <LayoutDashboard>
      <div
        v-if="isLoading"
        class="box bg-white border-radius pt-5 text-center"
      >
        <div class="spinner-border spinner-border-sm">
          <span class="sr-only">
            Loading...
          </span>
        </div>
      </div>
      <div
        v-if="!isLoading"
        class="box bg-white border-radius p-4"
      >
        <div class="row">
          <div class="col-md-5 col-lg-4 col-xl-3 p-0">
            <div class="parent-button">
              <div class="children-button button-upload-image">
                <input
                  id="file"
                  ref="file"
                  type="file"
                  accept="image/*"
                  @change="onFileChange"
                >
                <label for="file">
                  <img src="@/assets/icon/change-photo.png">
                </label>
              </div>
              <img
                v-if="!form.avatar && !avatar_url"
                src="@/assets/icon/guest.png"
                class="image-width pl-3"
                alt="profile-icon"
              >
              <img
                v-if="!form.avatar && avatar_url"
                :src="avatar_url"
                class="image-width rounded-circle"
                alt="profile-icon"
              >
              <img
                v-if="form.avatar && !avatar_url"
                :src="form.avatar"
                class="image-width rounded-circle"
                alt="profile-icon"
              >
              <img
                v-if="form.avatar && avatar_url"
                :src="avatar_url"
                class="image-width rounded-circle"
                alt="profile-icon"
              >
            </div>
          </div>
          <div class="col-md-7 col-lg-8 col-xl-9 pt-3 pt-lg-5">
            <div class="text-size-one font-weight-bold">
              {{ userData.fullname }}
            </div>
            <div class="mt-2 text-secondary">
              {{ userData.role ? userData.role.name : 'N/A' }}
            </div>
            <div class="row m-0 p-0 mt-4 col-lg-8 col-xl-6 text-center">
              <div class="col-6 p-0 pr-2">
                <div
                  class="btn-info border border-info rounded cursor-pointer p-2"
                  @click="saveProfile"
                >
                  <small>{{ $t('user-profile.button.save') }}</small>
                </div>
              </div>
              <div class="col-6 p-0 pl-2">
                <div
                  v-if="!userData.isActiveDirectory"
                  data-toggle="modal"
                  data-target="#modalPassword"
                  class="btn-outline-info border border-info cursor-pointer rounded p-2"
                  @click="showModal('password')"
                >
                  <small>{{ $t('user-profile.button.password') }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <div class="mb-4">
            <div class="text-info font-weight-bold border-bottom">
              {{ $t('user-profile.head.personal') }}
            </div>
            <div class="row m-0">
              <div class="col-md-8 col-lg-5 col-xl-4 p-0 mt-2">
                <div class="mb-3">
                  <div>
                    <small class="font-weight-bold">{{ $t('user-profile.label.username') }}</small>
                  </div>
                  <div>
                    <input
                      v-model="$v.form.username.$model"
                      type="text"
                      class="form-control form-control-sm"
                      :class="{ 'is-invalid': $v.form.username.$error }"
                      :disabled="userData.hrisEmpId || (!userData.hrisEmpId && userData.isActiveDirectory)"
                    >
                  </div>
                  <div
                    v-if="!$v.form.username.required && $v.form.username.$error"
                    class="text-danger"
                  >
                    <small>
                      {{ $t("user-profile.form.invalid.username") }}
                    </small>
                  </div>
                  <div
                    v-if="!$v.form.username.maxLength"
                    class="text-danger"
                  >
                    <small>
                      {{ $t("registration.form-error.username-maxlength") }}
                    </small>
                  </div>
                  <div
                    v-if="!$v.form.username.alpha"
                    class="text-danger"
                  >
                    <small>
                      {{ $t("registration.form-error.username-alpha") }}
                    </small>
                  </div>
                </div>
                <div class="mb-3">
                  <div>
                    <small class="font-weight-bold">{{ $t('user-profile.label.email') }}</small>
                  </div>
                  <div>
                    <input
                      v-model="$v.form.email.$model"
                      type="text"
                      class="form-control form-control-sm"
                      :disabled="userData.hrisEmpId || (!userData.hrisEmpId && userData.isActiveDirectory)"
                      :class="{ 'is-invalid': $v.form.email.$error }"
                    >
                  </div>
                  <div
                    v-if="!$v.form.email.required && $v.form.email.$error"
                    class="text-danger"
                  >
                    <small>
                      {{ $t("user-profile.form.invalid.email") }}
                    </small>
                  </div>
                  <div
                    v-if="!$v.form.email.email"
                    class="text-danger"
                  >
                    <small>
                      {{ $t("user-profile.form.invalid.email-wrong") }}
                    </small>
                  </div>
                </div>
                <div class="mb-3">
                  <div>
                    <small class="font-weight-bold">{{ $t('user-profile.label.gender') }}</small>
                  </div>
                  <div>
                    <select
                      v-model="form.gender"
                      class="form-control form-control-sm"
                      :class="{ 'is-invalid': $v.form.gender.$error }"
                      :disabled="userData.hrisEmpId"
                    >
                      <option value="true">
                        {{ $t('user-profile.form.male') }}
                      </option>
                      <option value="false">
                        {{ $t('user-profile.form.female') }}
                      </option>
                    </select>
                  </div>
                  <div
                    v-if="!$v.form.gender.required && $v.form.gender.$error"
                    class="text-danger"
                  >
                    <small>
                      {{ $t("user-profile.form.invalid.gender") }}
                    </small>
                  </div>
                </div>
                <div class="mb-3">
                  <div>
                    <small class="font-weight-bold">{{ $t('user-profile.label.phone') }}</small>
                  </div>
                  <div>
                    <input
                      v-model.trim="$v.form.phoneNumber.$model"
                      type="text"
                      class="form-control form-control-sm"
                      :class="{ 'is-invalid': $v.form.phoneNumber.$error }"
                    >
                  </div>
                  <div
                    v-if="!$v.form.phoneNumber.required && $v.form.phoneNumber.$error"
                    class="text-danger"
                  >
                    <small>
                      {{ $t("user-profile.form.invalid.phone-number") }}
                    </small>
                  </div>
                  <div
                    v-if="!$v.form.phoneNumber.numeric"
                    class="text-danger"
                  >
                    <small>
                      {{ $t("user-profile.form.invalid.phone-number-numeric") }}
                    </small>
                  </div>
                </div>
              </div>
              <div class="d-none d-sm-block col-lg-1 col-xl-1 p-0 mt-2" />
              <div class="col-md-8 col-lg-5 col-xl-4 p-0 mt-2">
                <div class="mb-3">
                  <div>
                    <small class="font-weight-bold">{{ $t('user-profile.label.fullname') }}</small>
                  </div>
                  <div>
                    <input
                      v-model="$v.form.fullname.$model"
                      type="text"
                      class="form-control form-control-sm"
                      :disabled="userData.hrisEmpId || (!userData.hrisEmpId && userData.isActiveDirectory)"
                      :class="{ 'is-invalid': $v.form.fullname.$error }"
                    >
                  </div>
                  <div
                    v-if="!$v.form.fullname.required && $v.form.fullname.$error"
                    class="text-danger"
                  >
                    <small>
                      {{ $t("user-profile.form.invalid.fullname") }}
                    </small>
                  </div>
                </div>

                <div class="mb-3">
                  <div>
                    <small class="font-weight-bold">{{ $t('user-profile.label.birthdate') }}</small>
                  </div>
                  <div v-if="userData.hrisEmpId">
                    <div class="input-group">
                      <div
                        class="input-group-prepend"
                      >
                        <span
                          class="input-group-text text-dark"
                        ><i
                          class="fa fa-calendar"
                          aria-hidden="true"
                        /></span>
                      </div>
                      <input
                        v-model="form.birthdate"
                        type="text"
                        class="form-control form-control-sm"
                        readonly
                      >
                    </div>
                  </div>
                  <div v-if="!userData.hrisEmpId">
                    <div
                      class="input-group"
                      :class="{ 'border border-danger rounded': $v.form.birthdate.$error }"
                    >
                      <div
                        class="input-group-prepend icon-calendar"
                        @click="showCalendar(isShowCalendar)"
                      >
                        <span
                          class="input-group-text text-info bg-white"
                        ><i
                          class="fa fa-calendar"
                          aria-hidden="true"
                        /></span>
                      </div>
                      <div class="form-control form-control-sm col-12 p-0 text-input">
                        <DatePicker
                          v-if="isShowCalendar"
                          v-model="form.birthdate"
                          :model-config="modelConfig"
                          class="date-pick"
                          :max-date="new Date()"
                        />
                        <input
                          v-else
                          v-model="form.birthdate"
                          type="text"
                          class="pl-2 input-date"
                          placeholder="yyyy/mm/dd"
                          readonly
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="!$v.form.birthdate.required && $v.form.birthdate.$error"
                    class="text-danger"
                  >
                    <small>
                      {{ $t("user-profile.form.invalid.birthdate") }}
                    </small>
                  </div>
                </div>
                <div class="mb-3">
                  <div>
                    <small class="font-weight-bold">{{ $t('user-profile.label.address') }}</small>
                  </div>
                  <div>
                    <textarea
                      v-model="$v.form.address.$model"
                      type="text"
                      class="form-control form-control-sm"
                      :class="{ 'is-invalid': $v.form.address.$error }"
                    />
                  </div>
                  <div
                    v-if="!$v.form.address.required && $v.form.address.$error"
                    class="text-danger"
                  >
                    <small>
                      {{ $t("user-profile.form.invalid.address") }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-4">
            <div class="text-info font-weight-bold border-bottom">
              {{ $t('user-profile.head.organization') }}
            </div>
            <div class="row m-0">
              <div class="col-md-8 col-lg-5 col-xl-4 p-0 mt-2">
                <div class="mb-3">
                  <div>
                    <small class="font-weight-bold">{{ $t('user-profile.label.company') }}</small>
                  </div>
                  <div v-if="userData.hrisEmpId">
                    <input
                      v-model="form.company.name"
                      type="text"
                      class="form-control form-control-sm"
                      :disabled="userData.hrisEmpId"
                    >
                  </div>
                  <div v-if="!userData.hrisEmpId">
                    <select
                      v-model="form.company.id"
                      type="text"
                      class="form-control form-control-sm"
                    >
                      <option
                        v-for="(company, index) in dataApi.company"
                        :key="index"
                        :value="company.id"
                      >
                        {{ company.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="mb-3">
                  <div>
                    <small class="font-weight-bold">{{ $t('user-profile.label.organization') }}</small>
                  </div>
                  <div v-if="userData.hrisEmpId">
                    <input
                      v-model="form.workLocation.name"
                      type="text"
                      class="form-control form-control-sm"
                      :disabled="userData.hrisEmpId"
                    >
                  </div>
                  <div v-if="!userData.hrisEmpId">
                    <select
                      v-model="form.workLocation.id"
                      type="text"
                      class="form-control form-control-sm"
                    >
                      <option
                        v-for="(workLocation, index) in dataApi.workLocation"
                        :key="index"
                        :value="workLocation.id"
                      >
                        {{ workLocation.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="mb-3">
                  <div>
                    <small class="font-weight-bold">{{ $t('user-profile.label.work-location') }}</small>
                  </div>
                  <div>
                    <v-select
                      v-model="$v.form.workLocationActual.$model"
                      class="sm"
                      label="name"
                      :class="{ 'border border-danger': $v.form.workLocationActual.$error }"
                      :options="workLocationsActual"
                      :clearable="false"
                      :reduce="({ name }) => name"
                      :selectable="option => !option.hasOwnProperty('group')"
                    >
                      <template #option="{ group, name }">
                        <div v-if="group">
                          {{ group }}
                        </div>
                        {{ name }}
                      </template>
                    </v-select>
                  </div>
                  <div
                    v-if="!$v.form.workLocationActual.required && $v.form.workLocationActual.$error"
                    class="text-danger"
                  >
                    <small>
                      {{ $t("user-profile.form.invalid.work-location-actual") }}
                    </small>
                  </div>
                </div>
              </div>
              <div class="d-none d-sm-block col-lg-1 col-xl-1 p-0 mt-2" />
              <div class="col-md-8 col-lg-5 col-xl-4 p-0 mt-2">
                <div class="mb-3">
                  <div class="d-flex justify-content-between">
                    <small class="font-weight-bold">{{ $t('user-profile.label.nik') }}</small>
                    <div v-if="userData.hrisEmpId">
                      <small class="font-weight-bold text-success">
                        HRIS Linkage
                      </small>
                      <img
                        src="@/assets/icon/checklist-green.png"
                        alt=""
                      >
                    </div>
                    <div v-if="!userData.hrisEmpId">
                      <small class="font-weight-bold text-danger">
                        HRIS Linkage
                      </small>
                      <img
                        src="@/assets/icon/close.png"
                        alt=""
                      >
                    </div>
                  </div>
                  <div>
                    <input
                      v-model="$v.form.nric.$model"
                      type="text"
                      class="form-control form-control-sm"
                      :disabled="userData.hrisEmpId"
                      :class="{ 'is-invalid': $v.form.nric.$error }"
                    >
                  </div>
                  <div
                    v-if="!$v.form.nric.required && $v.form.nric.$error"
                    class="text-danger"
                  >
                    <small>
                      {{ $t("user-profile.form.invalid.nric") }}
                    </small>
                  </div>
                </div>
                <div class="mb-3">
                  <div>
                    <small class="font-weight-bold">{{ $t('user-profile.label.work-unit') }}</small>
                  </div>
                  <div v-if="userData.hrisEmpId">
                    <input
                      v-model="form.workUnit"
                      type="text"
                      class="form-control form-control-sm"
                      :class="{ 'is-invalid': $v.form.workUnit.$error }"
                      :disabled="userData.hrisEmpId"
                    >
                  </div>
                  <div v-if="!userData.hrisEmpId">
                    <select
                      v-model="form.workUnit"
                      type="text"
                      class="form-control form-control-sm"
                      :class="{ 'is-invalid': $v.form.workUnit.$error }"
                    >
                      <option
                        v-for="(workUnit, index) in dataApi.workUnit"
                        :key="index"
                        :value="workUnit.workUnitName"
                      >
                        {{ workUnit.workUnitName }}
                      </option>
                    </select>
                  </div>
                  <div
                    v-if="!$v.form.workUnit.required && $v.form.workUnit.$error"
                    class="text-danger"
                  >
                    <small>
                      {{ $t("user-profile.form.invalid.work-unit") }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-4">
            <div class="text-info font-weight-bold border-bottom">
              {{ $t('user-profile.head.other') }}
            </div>
            <div class="row m-0">
              <div class="col-md-8 col-lg-5 col-xl-4 p-0 mt-2">
                <div class="mb-3">
                  <div>
                    <small class="font-weight-bold">{{ $t('user-profile.label.role') }}</small>
                  </div>
                  <div>
                    <input
                      v-model="form.role.name"
                      type="text"
                      class="form-control form-control-sm"
                      disabled
                    >
                  </div>
                </div>
              </div>
              <div class="d-none d-sm-block col-lg-1 col-xl-1 p-0 mt-2" />
              <div class="col-md-8 col-lg-5 col-xl-4 p-0 mt-2">
                <div class="mb-3">
                  <div class="mb-2">
                    <small class="font-weight-bold">{{ $t('user-profile.label.comorbid') }}</small>
                  </div>
                  <toggle-button
                    :value="form.comorbid"
                    disabled
                    @change="!form.comorbid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutDashboard>
    <ModalSuccess
      v-if="modal.success"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
    <ModalUnsuccessful
      v-if="modal.unsuccessful"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
    <ModalPassword
      :id="userData.id"
    />
  </div>
</template>

<script>
import Api from '@/utils/Api'
import VSelect from 'vue-select'
import LayoutDashboard from '@/components/LayoutDashboard'
import ModalSuccess from '@/components/modal/ModalSuccess'
import ModalUnsuccessful from '@/components/modal/ModalUnsuccessful'
import ModalPassword from '@/components/modal/password/ModalPassword'
import DatePicker from 'v-calendar'
import { format } from 'date-fns'
import { ToggleButton } from 'vue-js-toggle-button'
import {
  required,
  numeric,
  helpers,
  requiredIf,
  email,
  minLength,
  maxLength,
  alpha
} from 'vuelidate/lib/validators'

const validateIf = (prop1, prop2, validator) =>
  helpers.withParams({ type: 'validatedIf', prop1, prop2 }, function (value, parentVm) {
    return !helpers.ref(prop1, this, parentVm) && !helpers.ref(prop2, this, parentVm) ? validator(value) : true
  })

export default {
  name: 'UserProfile',

  components: {
    VSelect,
    ToggleButton,
    DatePicker,
    ModalSuccess,
    LayoutDashboard,
    ModalPassword,
    ModalUnsuccessful
  },

  data () {
    return {
      user: JSON.parse(localStorage.getItem('profile')) || {},
      avatar_base64: '',
      userData: {
        company: {
          name: ''
        },
        workLocation: {
          name: ''
        },
        role: {
          name: ''
        }
      },
      form: {
        company: {
          name: ''
        },
        workLocation: {
          name: ''
        },
        role: {
          name: ''
        },
        workLocationActual: '',
        contractorId: ''
      },
      dataApi: {
        company: [],
        workLocation: [],
        workUnit: []
      },
      dateBirth: '',
      isShowCalendar: false,
      modelConfig: {
        type: 'string',
        mask: 'YYYY/MM/DD'
      },
      avatar_url: null,
      selectedFiles: null,
      modal: {
        textModal: '',
        success: false,
        unsuccessful: false,
        password: false
      },
      isLoading: false,
      workLocationsActual: []
    }
  },

  watch: {
    'form.birthdate' () {
      if (this.form.birthdate) {
        this.isShowCalendar = false
        const splitDate = this.form.birthdate.split('/')
        const date = new Date()
        const year = date.getFullYear().toString()
        this.errorDateBirth = splitDate[2] === year
      }
    }
  },

  async mounted () {
    await this.getDataUser()
    this.getCompany()
    this.getCompanyLocation()
    this.getWorkUnit()
    this.getWorkLocationsActual()
  },

  methods: {
    async getDataUser () {
      this.isLoading = true
      const dataLogin = JSON.parse(localStorage.getItem('profile'))
      const data = await Api.users.get(dataLogin.id)
      this.userData = JSON.parse(localStorage.getItem('profile'))
      this.form = data.data
      this.checkNull('userData', 'company')
      this.checkNull('userData', 'workLocation')
      this.checkNull('form', 'company')
      this.checkNull('form', 'workLocation')
      if (this.form.birthdate) {
        this.form.birthdate = format(new Date(this.form.birthdate), 'yyyy/MM/dd')
      }
      this.avatar_url = this.form.avatar ? this.form.avatar : ''
      this.isLoading = false
    },
    checkNull (parent, child) {
      if (!this[parent][child]) {
        this[parent][child] = {
          id: null,
          name: null
        }
      }
    },
    async getCompany () {
      const dataCompanyOwner = await Api.masterData.companies()
      this.dataApi.company = dataCompanyOwner.data.data
    },
    async getCompanyLocation (id) {
      const dataCompanyLocation = await Api.masterData.workLocations({
        Filters: [`companyId==${id || ''}`, 'IsOrganization==true'].join(',')
      })
      this.dataApi.workLocation = dataCompanyLocation.data.data
    },
    async getWorkUnit () {
      const dataWorkUnit = await Api.getWorkUnit()
      this.dataApi.workUnit = dataWorkUnit.data.data
    },
    async getWorkLocationsActual () {
      const { data } = await Api.masterData.workLocations({
        Filters: `companyId==${this.user.company ? this.user.company.id : ''}`
      })
      this.workLocationsActual = data.data.reduce((acc, curr) => {
        const newGroup = (!acc.find(a => a.group === curr.category) &&
          [{ group: curr.category, name: null }]) ||
          []
        return [
          ...acc,
          ...newGroup,
          curr
        ]
      }, [])
    },
    showCalendar (valueCalendar) {
      this.isShowCalendar = !valueCalendar
    },
    onFileChange (e) {
      const file = e.target.files[0]
      this.avatar_url = URL.createObjectURL(file)
      this.selectedFiles = this.$refs.file.files[0]
      this.createBase64Image(file)
    },
    createBase64Image (fileObject) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.avatar_base64 = e.target.result
      }
      reader.readAsDataURL(fileObject)
    },
    async saveProfile () {
      let formSend
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if (this.userData.hrisEmpId) {
          formSend = {
            phoneNumber: this.form.phoneNumber,
            address: this.form.address,
            workLocationActual: this.form.workLocationActual,
            contractorId: this.form.contractorId
          }
        } else {
          formSend = {
            phoneNumber: this.form.phoneNumber,
            address: this.form.address,
            gender: this.form.gender,
            birthdate: this.form.birthdate,
            companyId: this.form.company.id,
            workLocationId: this.form.workLocation.id,
            workLocationActual: this.form.workLocationActual,
            workUnit: this.form.workUnit,
            nric: this.form.nric,
            contractorId: this.form.contractorId
          }
        }
        if (this.avatar_base64) {
          formSend.avatar = this.avatar_base64
        }
        if (!this.userData.hrisEmpId && !this.userData.isActiveDirectory) {
          if (this.form.email !== this.userData.email) {
            formSend.email = this.form.email
          }
          if (this.form.username !== this.userData.username) {
            formSend.username = this.form.username
          }
          formSend.fullname = this.form.fullname
        }
        const data = await Api.users.put(this.userData.id, formSend)
        if (data.status === 200) {
          if (this.$i18n.locale === 'en') {
            this.modal.textModal = 'Success'
          }
          if (this.$i18n.locale === 'id') {
            this.modal.textModal = 'Sukses'
          }
          this.fetchProfile()
          this.showModal('success')
        } else if (data.status === 409) {
          if (this.$i18n.locale === 'en') {
            this.modal.textModal = this.modal.textModal = data.data.message.messageEng
          }
          if (this.$i18n.locale === 'id') {
            this.modal.textModal = this.modal.textModal = data.data.message.messageIdn
          }
          this.showModal('unsuccessful')
        }
      }
    },
    async fetchProfile () {
      const { data } = await Api.users.me()
      localStorage.setItem('profile', JSON.stringify(data))
    },
    showModal (modalname) {
      this.modal[modalname] = true
    },
    closeModal (modalname) {
      this.modal[modalname] = false
      if (modalname === 'success') {
        this.$router.push({
          name: 'user-profile'
        })
      }
    }
  },
  validations: {
    form: {
      phoneNumber: {
        required,
        numeric: helpers.regex(numeric, /^[+0-9]*$/i)
      },
      address: {
        required
      },
      gender: {
        required: requiredIf(function () {
          return !this.userData.hrisEmpId
        })
      },
      username: {
        required: requiredIf(function () {
          return !this.userData.hrisEmpId && !this.userData.isActiveDirectory
        }),
        alpha: helpers.regex(alpha, /^(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+(?<![_.])$/i),
        minLength: validateIf('hrisEmpId', 'isActiveDirectory', minLength(8)),
        maxLength: maxLength(20)
      },
      email: {
        required: requiredIf(function () {
          return !this.userData.hrisEmpId
        }),
        email
      },
      fullname: {
        required: requiredIf(function () {
          return !this.userData.hrisEmpId
        })
      },
      nric: {
        required: requiredIf(function () {
          return !this.userData.hrisEmpId
        })
      },
      workUnit: {
        required: requiredIf(function () {
          return !this.userData.hrisEmpId
        })
      },
      birthdate: {
        required: requiredIf(function () {
          return !this.userData.hrisEmpId
        })
      },
      workLocationActual: {
        required: requiredIf(function () {
          return !this.userData.hrisEmpId
        })
      }
    }
  }
}
</script>

<style scoped>
.box {
  height: 587px;
  overflow: auto;
}
.bg {
  background-color: #f5efff;
  min-height: 750px;
}
.border-radius {
  border-radius: 11px;
}
.text-size-one {
  font-size: 20px;
}
.cursor-pointer {
  cursor: pointer !important;
}
textarea {
  resize: none;
}
.date-pick {
  height: 240px;
  background-color: white !important;
  z-index: 1;
}
.input-date {
  width: 100%;
  height: 100%;
  border: none;
}
input:focus {
  outline: none !important;
}
.icon-calendar {
  cursor: pointer;
}
.parent-button {
  position: relative;
  display: inline-block;
}
.children-button {
  position: absolute;
  top: 20px;
  left: 160px;
  z-index: 1;
}
.image-width {
  width: 200px;
  height: 200px;
  object-fit: cover;
}
input[type="file"] {
  display: none;
}

@media screen and (max-width: 576px) {
  .bg {
    min-height: 1600px;
  }
}
@media screen and (max-width: 768px) {
  .bg {
    min-height: 800px;
  }
}
@media screen and (max-width: 1024px) {
  .bg {
    min-height: 900px;
  }
}
</style>
